import script from "./VehicleEditModal.vue?vue&type=script&setup=true&name=VehicleEditModal&lang=js"
export * from "./VehicleEditModal.vue?vue&type=script&setup=true&name=VehicleEditModal&lang=js"

import "./VehicleEditModal.vue?vue&type=style&index=0&id=24a1c129&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24a1c129"]])

export default __exports__